<template>
	<section>

    <el-card v-for="x in this.content" v-bind:key="x.id" class="box-card-component" :style="bodystyle(x.hotnews)">
      <div slot="header" class="box-card-header">
        <h1><span v-if="x.hotnews" style='color:red'>HOT NEWS: </span><span v-html="x.newstitle"></span></h1>
      </div>
      <div>
        <img v-if="x.newsimage != ''" :src="x.newsimage" style='float:right;width:250px;margin-bottom:20px'>
        <p v-html="x.newstext"></p>
        <span style='break:both;font-size:10px;float:right;margin-bottom:5px;clear:both'>Created: {{x.newscreated}} By: {{x.newsby}}</span>
      </div>
    </el-card>
    
		<!-- Toolbar -->
	
		<el-col :span="24" class="toolbar">
			<el-pagination layout="prev,pager,next,jumper,sizes" @current-change="selectPage" :total="mainTotal" style="float:right;"
                     :current-page='currentPage' :page-sizes="[10, 15, 25, 50, 100, 1000]" @size-change="selectPagesize" :page-size="pageSize"></el-pagination>
      <span style='font-size:80%;margin:9px;float:right'>{{mainTotal}} items found</span>
			</el-col>
    
	</section>
</template>

<script>
  import settings from '../../common/AppSettings';
 	import util     from '../../common/AppUtil';
  import text     from '../../common/AppText';
  import api      from '../../api/system/xshownews';

	export default {
		data() {
			return {
        QID         : util.Initialize(this.$router,"XL"),
        util        : util,
        stack       : {},
			  lang        : text.data,
				pageSize    : settings.pageSize,
 		  	serverPaging: false,

				APICode     : "XNews",
        content: [],
				counter: {},
				currentPage: 1,
				mainTotal: 0,
		
				listLoading: false,
				xeditFormVisible: false,// Of de bewerkingsinterface wordt weergegeven
				xeditLoading: false,
				xeditForm: {},			
			}
		},
		
		methods: {
		  bodystyle: function(hot) {
        if (hot)  return "background-color:#eaf3ff;x:rgb(234 243 255);";
        else return "";
      },
      
      xstartSearch: function() {
        this.currentPage = 1;
        this.content = [];        
        this.getRecords();
      },
    // paginering wissel, reload page			
		  selectPagesize: function(size) {
				settings.pageSize = size;
				this.showPagedData();
			},
			selectPage: function(page) {
				this.currentPage = page;								
				this.showPagedData();
			},
			showPagedData: function() {
				if (this.serverPaging) this.getRecords();
				else this.content = this.contentSaved.slice((this.currentPage - 1) * 
				                    settings.pageSize,this.currentPage * settings.pageSize);
      },

			// Ophalen record(s) via API
			getRecords() {				
        let parg = {};

				this.listLoading = true;
				
				api.getNews(parg).then((res) => {						
          util.processMainResults(res);
          this.codes = util.codes;          
          this.mainTotal = util.payload[this.APICode].length;         
          if (this.mainTotal > 0)
          {
            if (this.serverPaging)
           	  this.content = util.getMainPayload(this.APICode);
			  		else {
 				  		this.contentSaved = util.getMainPayload(this.APICode);
  				    if (this.contentSaved.length > 0)
    				    this.selectPage(1);
  					}
          }
					else {
            this.content = [];
            this.contentSaved = [];
          }
          this.listLoading = false;
				})
        .catch((error) => {
          util.serverError(this);
        });


			},
		},

		mounted() {
			this.related = settings.getRelated();
			this.getRecords();
		}
	}

</script>

<style>
 div.el-card__header {padding:0px 20px !important;}
 .box-card-component {margin:30px 20px;}
</style>


// WEBPACK FOOTER //
// xshownews.vue?6087c62a